import WorkSection from './WorkSection';

class Work {
  constructor(wWidth) {
    this.wWidth = wWidth;
    this.$container = $('.work');
    this.$sections = this.$container.find('.work__section');
    this.sections = [];

    this.init();
  }

  init() {
    this.$sections.each((i, section) => {
      this.sections.push(
        new WorkSection({
          el: section,
          wWidth: this.wWidth,
        })
      );
    });
  }

  onResize(wWidth) {
    this.wWidth = wWidth;
    this.sections.forEach((section) => {
      if (section.onResize) section.onResize(this.wWidth);
    });
  }
}

export default Work;
